import logo from './logo.svg';
import './App.css';
import AppStore from './components/AppStore'

function App() {
  return (
    <AppStore />
  );
}

export default App;
